import * as ReactBootstrap from 'react-bootstrap'
import { ICONS, Slider } from '../../../components'
import { DeviceWarranty } from './DeviceWarranty'
import { RunDiagnosisForm } from './diagnostics'
import { PartDataTable } from '../../../GSXComponents'
import { TicketListPage } from '../TicketListPage'
import { GSXLogTable } from './GSXLogTable'
import { DeviceSupportPackages } from './DeviceSupportPackages'

export type DeviceActionProps = {
  identifier: string
  onDeviceInfo: (deviceInfo: any) => void
}

export const DeviceActions = ({
  identifier,
  onDeviceInfo,
}: DeviceActionProps): JSX.Element => {
  return (
    <div onClick={(e) => e.stopPropagation()} className="text-end">
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle split={true} variant="dark" />
        <ReactBootstrap.Dropdown.Menu>
          <Slider
            sliderWidth={'50vw'}
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Warranty Information</span>
              </>
            }
            header={
              <>
                <span className="me-2">{ICONS.VIEW} </span>
                <span className="ps-2">Warranty Information for</span>
                <span className="ms-2">{identifier}</span>
              </>
            }
            buttonType="dropdown"
          >
            <DeviceWarranty
              device_identifier={identifier}
              onDeviceInfo={onDeviceInfo}
            />
          </Slider>

          <Slider
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Run Diagnosis</span>
              </>
            }
            header={
              <span>
                {ICONS.VIEW}Run Diagnosis for
                <span className="ps-2">{identifier}</span>
              </span>
            }
            buttonType="dropdown"
          >
            <RunDiagnosisForm device_identifier={identifier} />
          </Slider>

          <Slider
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Device Parts </span>
              </>
            }
            header={
              <span>
                {ICONS.VIEW}Device Parts for
                <span className="ps-2">{identifier}</span>
              </span>
            }
            buttonType="dropdown"
          >
            <PartDataTable device_identifier={identifier} />
          </Slider>
          <Slider
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Previous Tickets </span>
              </>
            }
            header={
              <span>
                {ICONS.VIEW}Previous Tickets
                <span className="ps-2">{identifier}</span>
              </span>
            }
            buttonType="dropdown"
          >
            <TicketListPage defaultFilters={{ device: identifier }} />
          </Slider>

          <Slider
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Previous Call Log </span>
              </>
            }
            header={
              <span>
                <span className="me-2">{ICONS.VIEW}</span>Previous Call Log
                <span className="ps-2">{identifier}</span>
              </span>
            }
            buttonType="dropdown"
          >
            <GSXLogTable device_identifier={identifier} />
          </Slider>

          <Slider
            title={
              <>
                <span className="me-2">{ICONS.VIEW}</span>
                <span>Support Packages </span>
              </>
            }
            header={
              <span>
                <span className="me-2">{ICONS.VIEW}</span>Support Packages for
                <span className="ps-2">{identifier}</span>
              </span>
            }
            buttonType="dropdown"
          >
            <DeviceSupportPackages device_identifier={identifier} />
          </Slider>
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    </div>
  )
}
